<div class="popup-container">

  <!-- Close — floats over the image corner, sibling of image-wrap so no overflow clipping -->
  <button type="button" class="close-btn" (click)="close()" aria-label="Cerrar">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
         viewBox="0 0 24 24" fill="none" stroke="currentColor"
         stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
         aria-hidden="true">
      <line x1="18" y1="6" x2="6" y2="18"></line>
      <line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>
  </button>

  <!-- Image — clickable, with subtle hover overlay -->
  <div class="popup-image-wrap"
       role="button"
       tabindex="0"
       (click)="onImageClick()"
       (keydown.enter)="onImageClick()"
       aria-label="Ver detalle del pop-up">
    <img
      [src]="popup.imageUrl"
      alt="Promoción Art Stgo"
      class="popup-image"
      draggable="false"
    />
    <div class="popup-image-overlay" aria-hidden="true"></div>
  </div>

  <!-- CTA -->
  <button type="button" class="action popup-cta" (click)="onImageClick()">
    <span>{{ popup.ctaText || 'Ver detalle' }}</span>
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
         viewBox="0 0 24 24" fill="none" stroke="currentColor"
         stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
         aria-hidden="true">
      <path d="M5 12h14M12 5l7 7-7 7"/>
    </svg>
  </button>

</div>
